/* eslint-disable */

var MeetingsEmbedCode = (function (meetingsEmbedCodeModule) {
  var scriptSrc = (document.currentScript && document.currentScript.src) || '';
  var debugEnabled = scriptSrc.indexOf('debug=true') > -1;

  function debugLog(message) {
    if (debugEnabled) {
      console.debug(message);
    }
  }

  function elementContainsIFrame(element) {
    return element.querySelectorAll('iframe').length > 0;
  }
  meetingsEmbedCodeModule.elementContainsIFrame = elementContainsIFrame;

  function getParentPageUrl(origin, pathname) {
    if (origin || pathname) {
      return '&parentPageUrl=' + origin + pathname;
    }
    return '';
  }
  meetingsEmbedCodeModule.getParentPageUrl = getParentPageUrl;

  // helper for accessing hubutk
  function getUtk(name) {
    var cookieValue = null;
    if (document.cookie && document.cookie !== '') {
      var cookies = document.cookie.split(';');
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();
        var cookieName = name + '=';
        if (cookie.substring(0, name.length + 1) === cookieName) {
          cookieValue = cookie.substring(name.length + 1);
          break;
        }
      }
    }
    return cookieValue;
  }

  function getQueryParam(name) {
    var search = window.location.search;
    if (!search) return null;
    var params = search.substring(1).split('&');
    for (var i = 0; i < params.length; i++) {
      var pair = params[i].split('=');
      if (decodeURIComponent(pair[0]) === name) {
        return pair.length > 1 ? decodeURIComponent(pair[1]) : '';
      }
    }
    return null;
  }

  function isInCrossOriginFrame() {
    if (window.self === window.top) return false;
    try {
      void window.parent.document;
      return false;
    } catch (e) {
      return true;
    }
  }
  meetingsEmbedCodeModule.isInCrossOriginFrame = isInCrossOriginFrame;

  // returns hubspotutk of parent page to append to iframe src
  function getParentUtkParam(utk) {
    if (utk) {
      return '&parentHubspotUtk=' + encodeURIComponent(utk);
    }
    return '';
  }
  meetingsEmbedCodeModule.getParentUtkParam = getParentUtkParam;

  function getParentQueryParams(queryParamString) {
    if (queryParamString) {
      return '&' + queryParamString.substr(1);
    }
    return '';
  }
  meetingsEmbedCodeModule.getParentQueryParams = getParentQueryParams;

  function buildAbTestingParams(ab, abStatus, contentId) {
    var abParam = ab ? '&ab=' + ab : '';
    var abStatusParam = abStatus ? '&abStatus=' + abStatus : '';
    var contentIdParam = contentId ? '&contentId=' + contentId : '';
    return abParam + abStatusParam + contentIdParam;
  }
  meetingsEmbedCodeModule.buildAbTestingParams = buildAbTestingParams;

  // start of uuid generation functions copied from LiveMessageUI/MessagesWidgetShell/static/js/hsGenerator.js
  function mathRandomUuid() {
    var d = new Date().getTime();
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  function cryptoUuid() {
    var cryptoLib = window.crypto || window.msCrypto;
    var buf = new Uint16Array(8);

    cryptoLib.getRandomValues(buf);

    var S4 = function (num) {
      var ret = num.toString(16);
      while (ret.length < 4) {
        ret = '0' + ret;
      }
      return ret;
    };

    return (
      S4(buf[0]) +
      S4(buf[1]) +
      S4(buf[2]) +
      S4(buf[3]) +
      S4(buf[4]) +
      S4(buf[5]) +
      S4(buf[6]) +
      S4(buf[7])
    );
  }

  function generateUtk() {
    var cryptoLib = window.crypto || window.msCrypto;
    if (
      typeof cryptoLib != 'undefined' &&
      typeof cryptoLib.getRandomValues != 'undefined' &&
      typeof window.Uint16Array != 'undefined'
    ) {
      return cryptoUuid();
    }
    return mathRandomUuid();
  }
  // end uuid generation functions

  // generate our own utk if one does not exist on the window or as a cookie,
  // persist utk for other scripts use and for analytics to set on the tracker
  function getOrSetHubspotUtk() {
    var utk = window.__hsUserToken || getUtk('hubspotutk');
    if (!utk) {
      var newUtk = generateUtk();
      utk = newUtk;
      window.__hsUserToken = newUtk;
    }
    return utk;
  }
  meetingsEmbedCodeModule.getOrSetHubspotUtk = getOrSetHubspotUtk;

  var whitelist = [
    'https://local.hubspot.com',
    'https://local-eu1.hubspot.com',
    'https://local.hubspotqa.com',
    'https://local-eu1.hubspotqa.com',
    'https://app.hubspot.com',
    'https://app-eu1.hubspot.com',
    'https://app.hubspotqa.com',
    'https://app-eu1.hubspotqa.com',
    'https://meetings.hubspot.com',
    'https://meetings-eu1.hubspot.com',
    'https://meetings.hubspotqa.com',
    'https://meetings-eu1.hubspotqa.com',
  ];

  function isHubSpotOrigin(origin) {
    return whitelist.indexOf(origin) > -1;
  }
  meetingsEmbedCodeModule.isHubSpotOrigin = isHubSpotOrigin;

  function resize(e, iframe) {
    var key = e.message ? 'message' : 'data';
    var data = e[key];

    if (
      (isHubSpotOrigin(e.origin) || e.origin.indexOf(window.origin) > -1) &&
      data.height
    ) {
      iframe.style.height = data.height + 'px';
    }
  }
  meetingsEmbedCodeModule.resize = resize;

  var _hsp = (window._hsp = window._hsp || []);

  function addPrivacyConsentListener(e, iframe) {
    if (e && e.data === 'readyForConsentListener') {
      _hsp.push([
        'addPrivacyConsentListener',
        function (consent) {
          var allowed = consent.allowed;
          var currentCategories = consent.categories;

          var shouldTrackAnalytics = allowed || currentCategories.analytics;

          iframe.contentWindow.postMessage(
            { type: 'privacy-consent', shouldTrackAnalytics },
            '*'
          );
        },
      ]);
    }
  }
  meetingsEmbedCodeModule.addPrivacyConsentListener = addPrivacyConsentListener;

  function appendMeetingsIframe(container, pageInfo) {
    debugLog(
      '[MeetingsEmbed] appendMeetingsIframe — utk: ' +
        pageInfo.utk +
        ' origin: ' +
        pageInfo.origin
    );
    var src = container.dataset.src;
    var title = container.dataset.title;
    var iframe = document.createElement('iframe');
    var ab = container.dataset.ab;
    var abStatus = container.dataset.abStatus;
    var contentId = container.dataset.contentId;

    ///// Iframe attributes
    container.height = '100%';
    iframe.src =
      src +
      meetingsEmbedCodeModule.getParentUtkParam(pageInfo.utk) +
      meetingsEmbedCodeModule.getParentPageUrl(
        pageInfo.origin,
        pageInfo.pathname
      ) +
      meetingsEmbedCodeModule.getParentQueryParams(pageInfo.queryParams) +
      meetingsEmbedCodeModule.buildAbTestingParams(ab, abStatus, contentId);

    if (title) {
      iframe.title = title;
    }
    iframe.width = '100%';
    iframe.style.minWidth = '312px';
    iframe.style.minHeight = '615px';
    iframe.style.height = '756px';
    iframe.style.border = 'none';

    iframe.setAttribute('data-hs-ignore', 'true');

    container.appendChild(iframe);

    // Listen for messages from iframe
    window.addEventListener('message', function (e) {
      meetingsEmbedCodeModule.resize(e, iframe);
    });
    window.addEventListener('message', function (e) {
      meetingsEmbedCodeModule.addPrivacyConsentListener(e, iframe);
    });

    return iframe;
  }

  function createMeetingsIframe(selector) {
    var containers = document.querySelectorAll(selector);
    var iframes = [];
    debugLog(
      '[MeetingsEmbed] createMeetingsIframe — selector: ' +
        selector +
        ' found: ' +
        containers.length
    );

    var i;
    for (i = 0; i < containers.length; i++) {
      var container = containers[i];

      if (elementContainsIFrame(container)) {
        debugLog(
          '[MeetingsEmbed] container ' +
            i +
            ' — skipping, iframe already exists'
        );
        // iframe already appended from a previous script
        continue;
      }

      if (meetingsEmbedCodeModule.isInCrossOriginFrame()) {
        // CTA scenario: we're in a cross-origin iframe and cannot read
        // the customer page's cookies directly. The CTA passes the
        // visitor's UTK as a query param, so use that instead.
        var ctaUtk = getQueryParam('utk');
        debugLog(
          '[MeetingsEmbed] FLOW: cross-origin CTA — utk from query param: ' +
            ctaUtk
        );

        iframes.push(
          appendMeetingsIframe(container, {
            utk: ctaUtk,
            origin: '',
            pathname: '',
            queryParams: window.location.search,
          })
        );
      } else {
        // Direct embed: read local cookie/generate UTK, render immediately.
        var parentUtk = meetingsEmbedCodeModule.getOrSetHubspotUtk();
        debugLog('[MeetingsEmbed] FLOW: direct embed — utk: ' + parentUtk);

        iframes.push(
          appendMeetingsIframe(container, {
            utk: parentUtk,
            origin: window.location.origin,
            pathname: window.location.pathname,
            queryParams: window.location.search,
          })
        );
      }
    }

    return iframes;
  }
  meetingsEmbedCodeModule.createMeetingsIframe = createMeetingsIframe;

  createMeetingsIframe('.meetings-iframe-container');

  if (!window.hbspt) {
    window.hbspt = {};
  }

  if (!window.hbspt.meetings) {
    window.hbspt.meetings = {};
  }

  window.hbspt.meetings.create = createMeetingsIframe;

  if (typeof exports === 'object') {
    module.exports = meetingsEmbedCodeModule;
  }

  return meetingsEmbedCodeModule;
})(MeetingsEmbedCode || {});
